module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-enquiry-ebook-0deba8b90511b2f288995b46c100501f.png";